export type LocalWorkspaceHeaderControl = "collapse-projects" | "add-project";

export function getLocalWorkspaceHeaderControls(): readonly LocalWorkspaceHeaderControl[] {
  return ["collapse-projects", "add-project"];
}

export function shouldRenderProjectEmptyState(input: {
  readonly projectExpanded: boolean;
  readonly hasThreads: boolean;
}): boolean {
  return input.projectExpanded && !input.hasThreads;
}
